<template>
  <UIInputDynamicList
    v-model="tagValue"
    v-model:search="searchValue"
    :data
    :size
    @click:new="handleCreate"
    @ready="onReady"
  />
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue'

import { DropdownListData, InputSize } from '@types'

import { UIInputDynamicList } from '@ui/fields'

type Props = {
  list: DropdownListData[]
  focusOnLoad?: boolean
}

const props = defineProps<Props>()

const tagValue = defineModel<string>({ default: undefined })
const searchValue = defineModel<string>('search', { default: '' })

const size = inject<InputSize>('size')

const innerData = ref<DropdownListData[]>([])

const data = computed(() => {
  const merged = [...props.list, ...innerData.value]
  if (tagValue.value && !merged.some(item => item.value === tagValue.value)) {
    merged.push({ value: tagValue.value, label: tagValue.value })
  }
  return merged
})

const addValueToList = (value: string) => {
  if (innerData.value.find(item => item.value === value)) return
  innerData.value.push({ value, label: value })
}

const handleCreate = async (value: string, callback: () => void) => {
  if (value) {
    addValueToList(value)
    tagValue.value = value
  }
  callback()
}

const onReady = (e: any) => {
  if (!props.focusOnLoad) return
  e?.focus()
}
</script>
